import ItineraryItem from './ItineraryItem'
import LunchTime from './LunchTime'
import Treatment from './Treatment'
import { merge } from 'lodash'

export default class SpaItineraryItem extends ItineraryItem {
  treatmentList () {
    if (!this.treatments) return []

    return this.treatments.map((_, index) => new Treatment(this, index))
  }

  lunchTimeList () {
    if (!this.lunch_times) return []

    return this.lunch_times.map((_, index) => new LunchTime(this, index))
  }

  validateCollection (collection) {
    const errors = {}
    collection.forEach(item => {
      merge(errors, item.validate())
    })
    return errors
  }

  validateFormInputs () {
    if (this.formFieldsInvalid === true) {
      return { form_fields: ['invalid'] }
    } else {
      return {}
    }
  }

  validate () {
    return {
      ...super.validate(),
      ...this.validateFormInputs(),
      ...this.validateCollection(this.treatmentList()),
      ...this.validateCollection(this.lunchTimeList())
    }
  }

  callbacks (container) {
    return {
      ...super.callbacks(container),

      updateNestedAttribute: (itineraryItemId, collectionModel, attribute, itemIndex, value) => {
        const item = container.itineraryItems.find(itineraryItemId)

        // eslint-disable-next-line new-cap
        const newValue = new collectionModel(item, itemIndex).update(attribute, value)
        item.errors = item.validate()

        return newValue
      },

      markFormFieldsAsInvalid: (itineraryItemId, value) => {
        const item = container.itineraryItems.find(itineraryItemId)

        if (item.formFieldsInvalid !== value) {
          item.updateAttribute(itineraryItemId, 'formFieldsInvalid', value)
          item.errors = item.validate()
        }

        return value
      }
    }
  }
}
